import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Standard utility for composing className strings.
 *   - `clsx` handles conditional / array / object inputs.
 *   - `tailwind-merge` de-duplicates conflicting Tailwind utilities so the
 *     last one wins (essential for `cn(base, override)` composition).
 *
 * Exported as the single conventional alias used across the project.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
